




import { Component, Vue, Prop } from 'vue-property-decorator';
import { EnquiryHistory } from '@/models/enquiry-history';

@Component
export default class EnquiryHistoryDescription extends Vue {
    @Prop({ required: true }) public entry: EnquiryHistory;

    public get description(): string {
        switch (this.entry.name) {
        case 'EnquiryCreated':
            return `Enquiry created by ${this.entry.generatedBy}`;
        case 'QuoteCreated':
            return `A quote has been created for this enquiry by ${this.entry.generatedBy}`;
        case 'EnquiryStatusChanged':
            return `Enquiry status changed to '${this.statusDescription(this.entry.data.status)}'`;
        case 'ApprovalCreated':
            return `Approval generated for this enquiry`;
        case 'ApprovalAccepted':
            return `Approval accepted by ${this.entry.generatedBy}`;
        case 'ApprovalRejected':
            return `Approval rejected by ${this.entry.generatedBy}`;
        case 'QuoteAccepted':
            return `Quote status changed to 'Approved'`;
        case 'QuoteRejected':
            return `Quote status changed to 'Rejected'`;
        case 'EnquiryDocumentCreated':
            return `Document '${this.entry.data.fileName}' added by ${this.entry.generatedBy}`;
        case 'EnquiryDocumentDeleted':
            return `Document '${this.entry.data.fileName}' removed by ${this.entry.generatedBy}`;
        case 'EnquiryCommentCreated':
            return `Comment added by ${this.entry.generatedBy}`;
        case 'EnquiryCommentDeleted':
            return `Comment removed by ${this.entry.generatedBy}`;
        case 'QuoteOrdered':
            return `Quote status changed to 'Order placed'`;
        case 'OrderCreated':
            return `Order placed by ${this.entry.generatedBy}`;
        case 'OrderReceived':
            return `Order status changed to 'Received'`;
        case 'OrderDelivered':
            return `Order status changed to 'Delivered'`;
        case 'QuoteOrderReceived':
            return `Quote status changed to 'Order received'`;
        case 'QuoteOrderDelivered':
            return `Quote status changed to 'Order delivered'`;
        default:
            return `${this.entry.name}`;
        }
    }

    private statusDescription(status: number): string {
        switch (status) {
        case 0:
            return `Awaiting quote`;
        case 1:
            return `Quote sent`;
        case 2:
            return `Quote approved`;
        case 3:
            return `Quote rejected`;
        case 4:
            return `Order placed`;
        case 5:
            return `Order received`;
        case 6:
            return `Order delivered`;
        default:
            return `Unknown`;
        }
    }
}
